module.exports = "<mat-card class=\"top-20\">\n  <mat-card-content>\n    <span class=\"font-roboto-bold font-size-16 text-red\">Archivos adjuntos ministro</span>\n\n    <ul>\n      <li *ngFor=\"let file of files\">\n        <a [href]=\"getUrlFile(file)\" target=\"_blank\">\n          {{file}}\n        </a>\n      </li>\n    </ul>\n\n  </mat-card-content>\n</mat-card>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/minister-files/minister-files.component.html
// module id = ./src/app/components/minister-files/minister-files.component.html
// module chunks = main